export default __webpack_public_path__ + "static/media/STL-Annual-Report.68a21287.pdf";